import React from 'react';
import { useLocation } from 'react-router-dom';

function SchedulesDetails() {
  const location = useLocation();
  const { item } = location.state || {}; 
  if (!item) {
    return <p>No data available</p>;
  }
  

  return (
    <div className="detail-page">
      <div className="subheading_wrap">
        <div>
          <h3 className="subheading_title">{item.ac.nama_ac}</h3>
        </div>
      </div>
      <div className="detail-content">
        <div className="item-detail">
          <div className="item-detail-left">Tanggal Pelayanan</div>
          <div className="item-detail-right">{item.tgl_service}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Merek AC</div>
          <div className="item-detail-right">{item.ac.merek_ac}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Serial Number</div>
          <div className="item-detail-right">
            {item.ac.serial_number != null ? item.ac.serial_number : '-'}
          </div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Ketinggian AC</div>
          <div className="item-detail-right">{item.ac.ketinggian_ac}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Kapasitas AC</div>
          <div className="item-detail-right">{item.ac.kapasitas_pk}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Keluhan/Permintaan Service</div>
          <div className="item-detail-right">{item.keluhan}</div>
        </div>
      </div>
    </div>
  );
}

export default SchedulesDetails;
